import { useEffect, useState } from "react";
import FullScreenIcon from "./fullScreenIcon";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { handleFullScreen, handleLockOrientation } from "redux-share/actions/controller.actions";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const FullScreen = () => {

    const { isFullScreen } = useAppSelector(({ controller: { firstPlay, isFullScreen } }) => ({ firstPlay, isFullScreen }), shallowEqual);

    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!conditions(ConditionName.isFirstPlay)) dispatch(setActiveElements(false));
    }, [isFullScreen])

    return (
        <div className="pl-relative pl-flex pl-items-center">
            <FullScreenIcon 
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
                onClick={() => {
                    handleFullScreen();
                    handleLockOrientation();
                }}
            />
            {showTooltip && <ControllbarTooltip title={`${conditions(ConditionName.isFullScreen) ? "خروج از" : ""} تمام صفحه (f)`} className="!pl-right-[-10px]"/>}
        </div>
    )
}

export default FullScreen;